import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useEffect, useState } from "react";
import { api } from "../api/client";
import { useAuth } from "../hooks/useAuth";
export default function NotificationBanner() {
    const { user } = useAuth();
    const [items, setItems] = useState([]);
    useEffect(() => {
        if (!user)
            return;
        let cancelled = false;
        async function poll() {
            try {
                const list = await api.get("/notifications?unread_only=true");
                if (!cancelled)
                    setItems(list);
            }
            catch {
                /* swallow — banner shouldn't break the app */
            }
        }
        poll();
        const t = setInterval(poll, 60_000);
        return () => {
            cancelled = true;
            clearInterval(t);
        };
    }, [user]);
    async function dismiss(id) {
        try {
            await api.post(`/notifications/${id}/read`);
            setItems((prev) => prev.filter((n) => n.id !== id));
        }
        catch {
            /* keep banner visible on error */
        }
    }
    if (!user || items.length === 0)
        return null;
    // Show only the most recent — full list lives in a future notifications page.
    const top = items[0];
    return (_jsxs("div", { className: `banner banner-${top.type}`, children: [_jsx("span", { children: top.message }), _jsx("button", { className: "btn-link", onClick: () => dismiss(top.id), children: "Dismiss" })] }));
}
